import {UtilsPrint} from "../utils/index.mjs";

export class ItineraryGroup{
    constructor(itineraries){
        var _itineraries = itineraries; 

        Object.defineProperty(this,'itineraries',{
            get : function(){ return _itineraries }
        })

    }
    // ==========
    // private 
    // ----------

    getValuesByCriteria(methodName, ...arg){  
        var itineraries = this.getItineraries();
        var set = new Set();
        if (itineraries){
            itineraries.forEach(itinerary =>{
                var val = itinerary[methodName].apply(itinerary,arg);
                set.add(val);
            })
        }
        return [...set.values()];
    }

    getItinerariesBy(...filters){
        var reduce = (itineraries, filter) => itineraries.filter(filter); 
        return filters.reduce(reduce,this.getItineraries());
    }



    // ==========
    // public
    // ----------
    getConstructor(){ return ItineraryGroup }

    getItineraries(){ return this.itineraries; }

    getDirections(){
        return this.getValuesByCriteria('getDirection',true,true)
    }

    getDowHashKeys(){
        return this.getValuesByCriteria('getDowHashKey')
    }

    getPatternHashKeys(){
        return this.getValuesByCriteria('getPatternHashKey')
    }

    getCutoffDate(){
        var itineraries = this.getItineraries();
        var cutoffDate; 
        itineraries.forEach(itinerary =>{
            var date = new Date(itinerary.getLastDateRangeTo());
            if (!cutoffDate) {  cutoffDate = date; return; }
            if ((date.valueOf() - cutoffDate.valueOf()) > 0) cutoffDate = date;  
        });
        return cutoffDate;
    }


    getItineraryGroupBy(...filters){
        return new ItineraryGroup(this.getItinerariesBy(...filters))
    }

    print(homeStation, schoolStation){
        var logOptions = {includePatterns: true, homeStation, schoolStation, includeDropoffPattern : true }
            UtilsPrint.printTable(this.getItineraries(),logOptions); // TMP 
    }



    // ==========
    // static
    // ----------
    static filterByDow(dow){
        return (itinerary)=>(itinerary.getDowHashKey() === dow)
    }

    static filterByDirection(direction){
        return (itinerary)=>(itinerary.getDirection(true, true) === direction )  // asname, consolidated
    }

    static filterByPatternHashKey(patternHashKey){
        return (itinerary)=>(itinerary.getPatternHashKey() === patternHashKey)
    }

}